import { render, staticRenderFns } from "./DevTools.vue?vue&type=template&id=28e11074&scoped=true"
import script from "./DevTools.vue?vue&type=script&lang=js"
export * from "./DevTools.vue?vue&type=script&lang=js"
import style0 from "./DevTools.vue?vue&type=style&index=0&id=28e11074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e11074",
  null
  
)

export default component.exports